// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","formPanel":"auth_panel__formPanel__Se4_F","panelWithCTA":"auth_panel__panelWithCTA__FoLVg"};